// .directive('hpImage',

/* @ngInject */
export default function HPImageDirective($http, HPConfig) {
    return {
        restrict: 'A',
        scope: {
            hpSrc: '@',
        },
        link(scope, element) {
            scope.$watch('hpSrc', (hpSrc) => {
                $http.get(hpSrc).then((result) => {
                    element[0].src = result.data;
                });
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/hpimage.directive.js